module.exports = __webpack_public_path__ + "media/images/icons/outlined/down-square-a699afe0c168ae4c33a06501349c52bf.svg";